import React from 'react'
import PropTypes from 'prop-types'
import { Divider, Grid, TextField, Radio, RadioGroup, FormControlLabel } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import { useExameCoincidencia } from './hooks/useExameCoincidencia'
import { useStyles } from './ExameCoincidencia.styles'

export const ExameCoincidenciaPerfis = (props) => {
  const { route } = props
  const classes = useStyles()
  const {
    formValues,
    errors,
    isFormValid,
    hasError,
    processandoAlteracaoRespostas,
    handleFinalizarExame,
    handleCasoChange,
    handleElementoChange,
    handleNomeCadaverChange,
    handleNumLaudoChange,
    handleRadioChange,
    handleVoltar,
  } = useExameCoincidencia()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      <Grid container spacing={3} className={classes.corpoFormulario}>
        {/* Seção 1: Caso A */}
        <SecaoGenerica titulo="CASO A">
          <Grid item xs={12} sm={12} md={12} className={classes.corpoFormulario}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  variant="outlined"
                  label="CÓDIGO"
                  required
                  fullWidth
                  value={formValues.casoA || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="casoA"
                  onChange={handleCasoChange}
                  error={hasError('casoA')}
                  helperText={hasError('casoA') ? errors.casoA : null}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  variant="outlined"
                  label="ELEMENTO"
                  required
                  fullWidth
                  value={formValues.elementoA || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="elementoA"
                  onChange={handleElementoChange}
                  error={hasError('elementoA')}
                  helperText={hasError('elementoA') ? errors.elementoA : null}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  variant="outlined"
                  label="NOME DO CADÁVER"
                  fullWidth
                  value={formValues.nomeCadaverA || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="nomeCadaverA"
                  onChange={handleNomeCadaverChange}
                  error={hasError('nomeCadaverA')}
                  helperText={hasError('nomeCadaverA') ? errors.nomeCadaverA : null}
                />
              </Grid>
              {/* RadioButtons para Caso A */}
              <Grid item xs={12} sm={12} md={12}>
                <RadioGroup
                  row
                  name="origemA"
                  value={formValues.origemA || ''}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="LOCAL_CRIME" control={<Radio color="primary" />} label="Local de crime" />
                  <FormControlLabel value="CADAVER" control={<Radio color="primary" />} label="Cadáver" />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </SecaoGenerica>

        {/* Seção 2: Caso B */}
        <SecaoGenerica titulo="CASO B">
          <Grid item xs={12} sm={12} md={12} className={classes.corpoFormulario}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  variant="outlined"
                  label="CÓDIGO"
                  required
                  fullWidth
                  value={formValues.casoB || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="casoB"
                  onChange={handleCasoChange}
                  error={hasError('casoB')}
                  helperText={hasError('casoB') ? errors.casoB : null}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  variant="outlined"
                  label="ELEMENTO"
                  required
                  fullWidth
                  value={formValues.elementoB || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="elementoB"
                  onChange={handleElementoChange}
                  error={hasError('elementoB')}
                  helperText={hasError('elementoB') ? errors.elementoB : null}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  variant="outlined"
                  label="NOME DO CADÁVER"
                  fullWidth
                  value={formValues.nomeCadaverB || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="nomeCadaverB"
                  onChange={handleNomeCadaverChange}
                  error={hasError('nomeCadaverB')}
                  helperText={hasError('nomeCadaverB') ? errors.nomeCadaverB : null}
                />
              </Grid>
              {/* RadioButtons para Caso B */}
              <Grid item xs={12} sm={12} md={12}>
                <RadioGroup
                  row
                  name="origemB"
                  value={formValues.origemB || ''}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="LOCAL_CRIME" control={<Radio color="primary" />} label="Local de crime" />
                  <FormControlLabel value="CADAVER" control={<Radio color="primary" />} label="Cadáver" />
                </RadioGroup>
              </Grid>
            </Grid>
          </Grid>
        </SecaoGenerica>

        {/* Seção 3: Laudo Mais Recente */}
        <SecaoGenerica titulo="LAUDO MAIS RECENTE">
          <Grid item xs={12} sm={12} md={12} className={classes.corpoFormulario}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  variant="outlined"
                  label="NÚMERO EXAME"
                  required
                  fullWidth
                  value={formValues.numLaudo || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="numLaudo"
                  inputProps={{ maxLength: 12 }}
                  onChange={handleNumLaudoChange}
                  placeholder="CP-FFFF-0000"
                  error={hasError('numLaudo')}
                  helperText={hasError('numLaudo') ? errors.numLaudo : null}
                />
              </Grid>
            </Grid>
          </Grid>
        </SecaoGenerica>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        {/* Rodapé: Ações */}
        <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
          <Grid item>
            <CustomButton
              variant="outlined"
              onClick={handleVoltar}
              startIcon={<ArrowBackIcon />}
            >
              Voltar
            </CustomButton>
          </Grid>
          <Grid item>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={handleFinalizarExame}
              disabled={!isFormValid}
              isLoading={processandoAlteracaoRespostas}
              startIcon={<SaveIcon />}
            >
              Finalizar
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  )
}

ExameCoincidenciaPerfis.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
  }).isRequired,
}
